import {createId} from './configurator.js';

export function newCustomChoice(existing = [], label = 'New choice') {
  return {id: createId('choice', existing.map(({id}) => id)), label, description: '', choiceType: 'variants', selectedByDefault: false, components: [], fields: []};
}

export function newCustomOption(existing = []) {
  return {id: createId('custom', existing.map(({id}) => id)), label: 'New custom option', description: '', minSelections: 0, maxSelections: 1, conditions: {mode: 'all', rules: []}, choices: [newCustomChoice([], 'Choice 1')]};
}

export function newIncludedItem(existing = []) {
  return {id: createId('include', existing.map(({id}) => id)), label: 'New component', type: 'base', optionValueIds: [], url: ''};
}

export function hideModal(id) {
  const modal = document.getElementById(id);
  if (modal && 'hideOverlay' in modal && typeof modal.hideOverlay === 'function') modal.hideOverlay();
}
